<template>
  <div class="about-yy">
    <div class="company-profile padding-main mobile-padding">
      <div class="profile-title-en">Company profile</div>
      <div class="profile-title">{{ $t('aboutYY.companyProfile') }}</div>
      <div class="company">{{ $t('common.yyName') }}</div>
      <div class="hidden-sm-and-down">
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip') }}</div>
      </div>
      <div class="hidden-md-and-up">
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip3') }}</div>
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip4') }}</div>
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip5') }}</div>
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip6') }}</div>
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip7') }}</div>
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip8') }}</div>
        <div class="profile-content">{{ $t('aboutYY.companyProfileTip9') }}</div>
      </div>

    </div>
    <div class="our-team padding-main mobile-padding">
      <div class="team-title">{{ $t('aboutYY.ourTeam') }}</div>
      <div class="team-content">
        <el-image src="/img/team_01.png"
                  fit="cover" />
        <el-image src="/img/team_02.png"
                  fit="cover" />
        <div class="right hidden-sm-and-down">
          <span>Our team</span>
        </div>
      </div>
    </div>
    <div class="enterprise-culture mobile-padding">
      <div class="culture-title">{{ $t('aboutYY.enterpriseCulture') }}</div>
      <div class="culture-content"
           v-html="$t('aboutYY.enterpriseCultureTip')" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'AboutYY',
  data() {
    return {
    }
  },
  
  methods: {

  }

}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
$padding: 18.75vw;

.padding-main {
  padding: 1.77vw $padding;
}
.about-yy {
  .company-profile {
    padding: 1.77vw 36.46vw 1.77vw $padding;
    height: 31.25vw;
    min-height: 500px;
    background-image: url('/img/about_yy.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .profile-title-en {
      font-size: 32px;
      margin-top: 7.29vw;
      margin-bottom: 1.04vw;
    }
    .profile-title {
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 1.52vw;
      // color: $mainColor;
    }
    .company {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 0.52vw;
    }
    .profile-content {
      text-indent: 2em;
      font-size: 18px;
      line-height: 35px;
    }
  }
  .our-team {
    // height: 49.89vw;
    padding-top: 3.125vw;
    padding-bottom: 6.25vw;
    text-align: center;
    .team-title {
      font-size: 26px;
      color: #3f3e3e;
      font-weight: bold;
      margin-bottom: 4.84vw;
    }
    .team-content {
      display: flex;
      .el-image {
        width: 23.75vw;
        margin-right: 1.56vw;
        filter: brightness(0.8);
        &:hover {
          filter: brightness(1);
        }
      }
      .right {
        flex: 1;
        background-color: $mainColor;
        font-size: 1.67vw;
        color: #f7fcfe;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          opacity: 0.5;
        }
        &:hover {
          span {
            opacity: 1;
          }
        }
      }
    }
  }
  .enterprise-culture {
    height: 23.958vw;
    background-image: url('/img/enterprise_culture.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    filter: brightness(0.8);
    &:hover {
      filter: brightness(1);
    }
    .culture-title {
      font-size: 26px;
      color: #3f3e3e;
      font-weight: bold;
      margin-bottom: 1.56vw;
    }
    .culture-content {
      font-size: 24px;
    }
  }
}
@media screen and (max-width: 992px) {
  .mobile-padding {
    height: auto !important;
    padding: 5.33vw $mobilePadding !important;
  }

  .about-yy {
    .company-profile {
      display: block;
      height: 106.67vw !important;
      background-image: none !important;
      background-color: $bgColor;
      text-align: center;
      min-height: auto;
      .profile-title-en {
        font-size: 6.4vw;
        margin-bottom: 3.33vw;
      }
      .profile-title {
        font-size: 4.27vw;
        margin-bottom: 3.33vw;
      }
      .company {
        font-size: 4.27vw;
        margin-bottom: 3.33vw;
      }
      .profile-content {
        text-align: center;
        font-size: 3.73vw;
        margin-bottom: 3.33vw;
        line-height: normal;
      }
    }
    .our-team {
      height: auto;
      text-align: center;
      .team-title {
        font-size: 18px;
      }
      .team-content {
        // display: flex;
        justify-content: space-between;
        .el-image {
          width: 45.33vw;
          margin-right: 0;
          filter: none;
          &:nth-child(1) {
            margin-bottom: 0;
          }
        }
        .right {
          font-size: 18px;
        }
      }
    }
    .enterprise-culture {
      height: 69.33vw !important;
      width: 100vw;
      filter: none;
      background-image: url('/img/enterprise_culture_mobile.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .culture-title {
        font-size: 4.27vw;
      }
      .culture-content {
        font-size: $mobileFontSize;
      }
    }
  }
}
</style>
